export function loginUrl() {
  if (import.meta.env.VITE_PLATFORM_CUSTOM_LOGIN_URL) {
    return import.meta.env.VITE_PLATFORM_CUSTOM_LOGIN_URL;
  }
  return `${window.location.protocol}//api.${base()}/api/v1/auth/login`;
}

export function registerUrl() {
  if (import.meta.env.VITE_PLATFORM_CUSTOM_REGISTER_URL) {
    return import.meta.env.VITE_PLATFORM_CUSTOM_REGISTER_URL;
  }
  return `${window.location.protocol}//api.${base()}/api/v1/auth/register`;
}

function base() {
  const hostnameParts = window.location.hostname.split(".");
  if (window.location.hostname === "localhost") {
    return "staging.funtico.com"; // it would not work from localhost anyway
  }
  if (window.location.hostname.split(".").length > 2) {
    hostnameParts.shift();
    return hostnameParts.join(".");
  }
  return window.location.hostname;
}
